import React from 'react';
import Typography from '@mui/material/Typography';
import renderHTML from 'html-react-parser';
import { Helmet } from 'react-helmet';

export default class FAQPage extends React.Component {

  render() {
    const { promotion, content } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{promotion.name} | FAQ</title>
        </Helmet>

        <Typography variant="h4" align="center">
          FAQ
        </Typography>

        <Typography variant="subtitle1" className="custom-tab-content">
          {content && renderHTML(content)}
        </Typography>
      </React.Fragment>
    )
  }
}
